import { render, staticRenderFns } from "./DailyTransfer.vue?vue&type=template&id=2be61197&scoped=true"
import script from "./DailyTransfer.vue?vue&type=script&lang=js"
export * from "./DailyTransfer.vue?vue&type=script&lang=js"
import style0 from "./DailyTransfer.vue?vue&type=style&index=0&id=2be61197&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be61197",
  null
  
)

export default component.exports